import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-6 px-4 border-t border-gray-800 text-center" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        <p className="font-bold text-white mb-2" data-id="element-169">
          💰 KIT COMPLETO EDUCACIÓN FINANCIERA
        </p>
        <p className="mb-3" data-id="element-170">© 2026 Kit Completo Educación Financiera™</p>
        <div className="flex justify-center gap-6 text-sm" data-id="element-171">
          <span className="cursor-pointer hover:text-white transition-colors" data-id="element-172">
            Términos
          </span>
          <span className="cursor-pointer hover:text-white transition-colors" data-id="element-173">
            Privacidad
          </span>
          <span className="cursor-pointer hover:text-white transition-colors" data-id="element-174">
            Soporte
          </span>
        </div>
      </div>
    </footer>;
}